import React from 'react';
import { useLocalizedStrings } from 'app/localization/Context';

import { ReactComponent as IconX } from 'images/general/x.svg';
import { ReactComponent as IconHome } from 'images/device/add-device/home.svg';
import { ReactComponent as IconRefresh } from 'images/general/refresh.svg';

export function ConnectingToDevice({ dismissHandler, selectedType }) {
    const ad = useLocalizedStrings().addDeviceProcess;

    return (
        <div className="add-device-page-content">
            <IconX className="nav-icon" /> <div className="nav-button" onClick={dismissHandler} />

            <div className="message-container">
                <div />
                <div className="message-content">
                    <div className="device-home-icons">
                        {React.createElement(selectedType.iconWhite, { className: "icon" })}
                        <div className="loading-box">
                            <div className="c-1" />
                            <div className="c-2" />
                            <div className="c-3" />
                        </div>
                        <IconHome className="icon" />
                    </div>
                    <div className="label">{ad.connecting}</div>
                </div>
                <div />
            </div>
        </div>
    );
}

export function ErrorOnAddDevice({ dismissHandler, onRetry, errorId }) {
    const ad = useLocalizedStrings().addDeviceProcess;

    return (
        <div className="add-device-page-content">
            <IconX className="nav-icon" /> <div className="nav-button" onClick={dismissHandler} />

            <div className="message-container">
                <div />
                <div className="message-content">
                    <IconX className="x-icon" />
                    <div className="label">{ad.errors[errorId]}</div>
                </div>
                <div />
            </div>

            <div className="bottom-blue-button" onClick={onRetry}>
                <div>{ad.retry}</div> <IconRefresh className="icon" />
            </div>
        </div>
    );
}
